import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import TabSelector from '../../components/TabSelector';
import QuoteReviewMakersharksScreen from '../../screens/Makersharks/QuoteReviewMakersharksScreen';
import RFQOverviewMakersharksScreen from '../../screens/Makersharks/RFQOverviewMakersharksScreen';
import SupplierListScreen from '../../screens/Makersharks/SupplierListScreen';
import ChooseSupplierScreen from '../../screens/Makersharks/ChooseSupplierScreen';
import BidSubmitMakersharkScreen from '../../screens/Makersharks/BidSubmitMakersharkScreen';

const options = [
  { id: 'review_quote', label: 'Review' },
  { id: 'rfq_overview', label: 'RFQ Overview' },
  { id: 'supplier_list', label: 'Supplier List' },
  { id: 'select_supplier', label: 'Select Supplier' },
  { id: 'bid_on_the_item', label: 'Bid on the Item' },
];

const MakersharksReviewPage = () => {
  const [currentTab, setCurrentTab] = useState('review_quote');
  const handleTabChange = (tab) => {
    setCurrentTab(tab);
  };

  const getCurrentSection = () => {
    if (currentTab === 'review_quote') {
      return <QuoteReviewMakersharksScreen handleTabChange={handleTabChange} />;
    } else if (currentTab === 'rfq_overview') {
      return <RFQOverviewMakersharksScreen handleTabChange={handleTabChange} />;
    } else if (currentTab === 'supplier_list') {
      return <SupplierListScreen handleTabChange={handleTabChange} />;
    } else if (currentTab === 'select_supplier') {
      return <ChooseSupplierScreen handleTabChange={handleTabChange} />;
    } else if (currentTab === 'bid_on_the_item') {
      return <BidSubmitMakersharkScreen handleTabChange={handleTabChange} />;
    }
  };

  return (
    <div className="flex flex-row">
      <div className="self-stretch">
        <Sidebar />
      </div>

      <div className="flex flex-col flex-grow px-10">
        <TabSelector
          options={options}
          handleTabChange={handleTabChange}
          currentTab={currentTab}
        />

        <div className="mt-5">{getCurrentSection()}</div>
      </div>
    </div>
  );
};

export default MakersharksReviewPage;
